import { render, staticRenderFns } from "./medicareDialog.vue?vue&type=template&id=bfe2d110"
import script from "./medicareDialog.vue?vue&type=script&lang=js"
export * from "./medicareDialog.vue?vue&type=script&lang=js"
import style0 from "./medicareDialog.vue?vue&type=style&index=0&id=bfe2d110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports